import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, f as createEventDispatcher, v as validate_component, e as escape, o as onDestroy, d as add_attribute, i as each } from "../../../../../chunks/ssr.js";
import "qr-scanner";
import { p as page } from "../../../../../chunks/stores.js";
import "../../../../../chunks/project.js";
import { A as Avatar } from "../../../../../chunks/Avatar.js";
import dayjs from "dayjs";
import { B as Button } from "../../../../../chunks/Button.js";
import { M as Modal } from "../../../../../chunks/Modal2.js";
import { H as Heading } from "../../../../../chunks/Heading.js";
const Card = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  return `<div class="shadow rounded px-3 bg-white">${slots.default ? slots.default({}) : ``}</div>`;
});
function roundToNearest15(date = /* @__PURE__ */ new Date()) {
  const minutes = 15;
  const ms = 1e3 * 60 * minutes;
  return new Date(Math.round(date.getTime() / ms) * ms);
}
const CheckInModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { showCheckInModal = false } = $$props;
  let { assignee } = $$props;
  let { realTime = false } = $$props;
  createEventDispatcher();
  const onScanCheckin = () => {
    if (realTime) {
      assignee.actualStart.value = /* @__PURE__ */ new Date();
      assignee.actualStart.stamp = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTime();
    } else {
      assignee.actualStart.value = roundToNearest15();
      assignee.actualStart.stamp = assignee.actualStart.value.getTime();
    }
  };
  if ($$props.showCheckInModal === void 0 && $$bindings.showCheckInModal && showCheckInModal !== void 0) $$bindings.showCheckInModal(showCheckInModal);
  if ($$props.assignee === void 0 && $$bindings.assignee && assignee !== void 0) $$bindings.assignee(assignee);
  if ($$props.realTime === void 0 && $$bindings.realTime && realTime !== void 0) $$bindings.realTime(realTime);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      {
        if (showCheckInModal) {
          onScanCheckin();
        }
      }
    }
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { open: showCheckInModal },
      {
        open: ($$value) => {
          showCheckInModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<div class="grid gap-3 grid-cols-2 my-10">${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div data-svelte-h="svelte-aep6eu">Dienstbeginn Neu</div> <div class="text-2xl">${escape(dayjs(assignee?.actualStart.value).format("HH:mm"))} Uhr</div>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div data-svelte-h="svelte-nsyp9n">Dienstbeginn Plan</div> <div class="text-2xl">${escape(dayjs(assignee?.plannedStart.value).format("HH:mm"))} Uhr</div>`;
            }
          })}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const CheckOutModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { showCheckOutModal = false } = $$props;
  let { assignee } = $$props;
  let { realTime = false } = $$props;
  let aboveFourHours = true;
  let displayBreak = false;
  const onScanCheckOut = () => {
    if (realTime) {
      assignee.actualEnd.value = /* @__PURE__ */ new Date();
      assignee.actualEnd.stamp = /* @__PURE__ */ (/* @__PURE__ */ new Date()).getTime();
    } else {
      assignee.actualEnd.value = roundToNearest15();
      assignee.actualEnd.stamp = assignee.actualEnd.value.getTime();
    }
  };
  if ($$props.showCheckOutModal === void 0 && $$bindings.showCheckOutModal && showCheckOutModal !== void 0) $$bindings.showCheckOutModal(showCheckOutModal);
  if ($$props.assignee === void 0 && $$bindings.assignee && assignee !== void 0) $$bindings.assignee(assignee);
  if ($$props.realTime === void 0 && $$bindings.realTime && realTime !== void 0) $$bindings.realTime(realTime);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      {
        if (showCheckOutModal) {
          aboveFourHours = dayjs().diff(dayjs(assignee.actualStart.value), "hours") >= 4;
          onScanCheckOut();
        } else {
          displayBreak = false;
        }
      }
    }
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { size: "xl", open: showCheckOutModal },
      {
        open: ($$value) => {
          showCheckOutModal = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${aboveFourHours ? `${validate_component(Heading, "Heading").$$render($$result, { tag: "h2", class: "text-center mt-5" }, {}, {
            default: () => {
              return `Checkout`;
            }
          })} <div class="grid gap-3 grid-cols-3 my-10">${displayBreak ? `${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div class="text-2xl" data-svelte-h="svelte-3k0fw1">15 min</div>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div class="text-2xl" data-svelte-h="svelte-1hu615c">30 min</div>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div class="text-2xl" data-svelte-h="svelte-1tppn5w">45 min</div>`;
            }
          })}` : `${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div class="text-2xl" data-svelte-h="svelte-1g9s71h">Mit Pause</div>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div class="text-2xl" data-svelte-h="svelte-jz0mem">Kein Pause</div>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { color: "dark", class: "h-36 grid" }, {}, {
            default: () => {
              return `<div class="text-2xl" data-svelte-h="svelte-701igp">Weiterarbeiten</div>`;
            }
          })}`}</div>` : `${validate_component(Heading, "Heading").$$render($$result, { tag: "h3", class: "text-center mt-5" }, {}, {
            default: () => {
              return `Sie sind bereits eingecheckt`;
            }
          })} <p class="text-center text-xl" data-svelte-h="svelte-1k0ty09">Möchten Sie auschecken?</p> <div class="grid gap-3 grid-cols-2 my-10">${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div data-svelte-h="svelte-nw6idb">JA</div> <div class="text-2xl">Arbeitszeit: ${escape(dayjs().diff(dayjs(assignee.actualStart.value), "hours", true))}</div>`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { class: "h-36 grid" }, {}, {
            default: () => {
              return `<div data-svelte-h="svelte-1v421cg">Nein,</div> <div class="text-2xl" data-svelte-h="svelte-701igp">Weiterarbeiten</div>`;
            }
          })}</div>`}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let expected;
  let $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => value);
  let videoElement = null;
  let project = null;
  let assignees = [];
  let showCards = [];
  let showCheckInModal = false;
  let showCheckOutModal = false;
  let currentAssignee = null;
  onDestroy(() => {
  });
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    expected = assignees.filter((x) => !x.actualStart.value).sort((a, b) => a.plannedStart.stamp - b.plannedStart.stamp);
    $$rendered = `${validate_component(CheckInModal, "CheckInModal").$$render(
      $$result,
      {
        realTime: project?.customer?.realTimeCheckin,
        assignee: currentAssignee,
        showCheckInModal
      },
      {
        assignee: ($$value) => {
          currentAssignee = $$value;
          $$settled = false;
        },
        showCheckInModal: ($$value) => {
          showCheckInModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${validate_component(CheckOutModal, "CheckOutModal").$$render(
      $$result,
      {
        realTime: project?.customer?.realTimeCheckin,
        assignee: currentAssignee,
        showCheckOutModal
      },
      {
        assignee: ($$value) => {
          currentAssignee = $$value;
          $$settled = false;
        },
        showCheckOutModal: ($$value) => {
          showCheckOutModal = $$value;
          $$settled = false;
        }
      },
      {}
    )} <div>${`<div class="h-[56px]"></div>`} <div class="my-5">${validate_component(Card, "Card").$$render($$result, {}, {}, {
      default: () => {
        return `<div class="grid grid-cols-3 gap-3 py-3"><video class="col-span-3 lg:col-span-2"${add_attribute("this", videoElement, 0)}></video> <div><ul class="px-3 h-96 overflow-y-auto">${each(showCards, (assignee) => {
          return `<li class="mb-3">${validate_component(Card, "Card").$$render($$result, {}, {}, {
            default: () => {
              return `<div class="flex gap-3 align-content-center py-3">${validate_component(Avatar, "Avatar").$$render($$result, { associate: assignee.employee }, {}, {})} <div class="text-coolGray-600 self-center">${escape(assignee.employee.firstName)} ${escape(assignee.employee.lastName)} </div></div> <div class="flex gap-3 py-3 text-coolGray-600"><span>${escape(dayjs(assignee.plannedStart.value).format("HH:mm [Uhr]"))}</span> <span data-svelte-h="svelte-1s4sarz">-</span> <span>${escape(dayjs(assignee.plannedEnd.value).format("HH:mm [Uhr]"))}</span></div> <div class="flex gap-3 py-3"><i class="las la-check-circle mt-1"></i> <div class="text-coolGray-600 ">${escape(dayjs(assignee.actualStart.value).format("HH:mm [Uhr]"))} </div></div> `;
            }
          })} </li>`;
        })}</ul></div></div>`;
      }
    })}</div> ${validate_component(Card, "Card").$$render($$result, {}, {}, {
      default: () => {
        return `<div class="grid grid-cols-2 gap-3 py-3"><div><h2 class="text-xl text-center text-neutral-600" data-svelte-h="svelte-1n5k6zy">Checked in</h2> <ul class="divide-y divide-gray-100 rounded-md border border-gray-200">${each(assignees.filter((x) => !!x.actualStart.value), (checkedIn) => {
          return `<li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">${validate_component(Avatar, "Avatar").$$render($$result, { associate: checkedIn.employee }, {}, {})} <span>${escape(checkedIn.employee.firstName)} ${escape(checkedIn.employee.lastName)}</span> <span>${escape(dayjs(checkedIn.plannedStart.value).format("HH:mm [Uhr]"))} - ${escape(dayjs(checkedIn.plannedEnd.value).format("HH:mm [Uhr]"))}</span> </li>`;
        })}</ul></div> <div><h2 class="text-xl text-center text-neutral-600" data-svelte-h="svelte-utqoiu">Expected</h2> <ul class="divide-y divide-gray-100 rounded-md border border-gray-200">${each(expected, (checkedIn) => {
          return `<li class="flex items-center justify-between py-4 pl-4 pr-5 text-sm leading-6">${validate_component(Avatar, "Avatar").$$render($$result, { associate: checkedIn.employee }, {}, {})} <span>${escape(checkedIn.employee.firstName)} ${escape(checkedIn.employee.lastName)}</span> <span>${escape(dayjs(checkedIn.plannedStart.value).format("HH:mm [Uhr]"))} - ${escape(dayjs(checkedIn.plannedEnd.value).format("HH:mm [Uhr]"))}</span> </li>`;
        })}</ul></div></div>`;
      }
    })}</div>`;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
